(() => {
  'use strict';

  if (window.feohwynnAtlasHeaderInitialized) return;
  window.feohwynnAtlasHeaderInitialized = true;

  const compactClass = 'feohwynn-atlas-header--scrolled';
  let headers = [];
  let ticking = false;
  let needsMeasurement = true;

  const refresh = () => {
    if (needsMeasurement) {
      headers = Array.from(document.querySelectorAll('[data-feohwynn-atlas-header]')).flatMap((header) => {
        const wrapper = header.closest('.hdr_wrap');
        if (!wrapper) return [];
        const configuredHeight = Number.parseFloat(getComputedStyle(wrapper).getPropertyValue('--fw-atlas-header-height')) || 0;
        const height = Math.max(configuredHeight, wrapper.getBoundingClientRect().height);
        return [{ wrapper, collapseAt: Math.max(72, height + 24) }];
      });
      needsMeasurement = false;
    }

    const scroll = window.scrollY;
    headers.forEach(({ wrapper, collapseAt }) => {
      const compact = wrapper.classList.contains(compactClass);
      const nextCompact = scroll > (compact ? 12 : collapseAt);
      if (compact !== nextCompact) wrapper.classList.toggle(compactClass, nextCompact);
    });
  };

  const requestRefresh = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      ticking = false;
      refresh();
    });
  };

  const requestMeasurement = () => {
    needsMeasurement = true;
    requestRefresh();
  };

  window.addEventListener('scroll', requestRefresh, { passive: true });
  window.addEventListener('resize', requestMeasurement, { passive: true });
  window.addEventListener('load', requestMeasurement, { once: true });
  document.addEventListener('shopify:section:load', requestMeasurement);
  document.addEventListener('shopify:section:unload', requestMeasurement);

  refresh();
})();
